module.exports = __webpack_public_path__ + "media/checkout/shipping_item-4ec768d6.png";